export const enum GAEvent {
  'PURCHASE' = 'purchase',
}

export interface GAData {
  [GAEvent.PURCHASE]: {
    currency: string;
    value: number;
    transaction_id: string;
    coupon?: string;
    shipping?: number;
    tax?: number;
    items: {
      item_id: string;
      item_name: string;
      affiliation?: string;
      coupon?: string;
      discount?: number;
      index?: number;
      item_brand?: string;
      item_category?: string;
      item_category2?: string;
      item_category3?: string;
      item_category4?: string;
      item_category5?: string;
      item_list_id?: string;
      item_list_name?: string;
      item_variant?: string;
      location_id?: string;
      price?: number;
      quantity?: number;
    }[];
  };
}

export const GAReport = (event: GAEvent, data: GAData[GAEvent]) => {
  if (import.meta.server) {
    return;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push({
    event,
    ...data,
  });
};
